/**
 * CTA Cards Module
 * Equalises .cta-card-title heights within each .cta-cards-grid so all titles
 * match the tallest one. Resets to natural height when cards collapse to a
 * single column (mobile stacked layout) so no artificial space is added.
 */

function equaliseCtaCardTitles(grid) {
  const titles = grid.querySelectorAll('.cta-card-title');
  if (titles.length < 2) return;

  // Always reset first so we measure natural (unwrapped) heights.
  titles.forEach(function (t) { t.style.minHeight = ''; });

  // Detect single-column layout by comparing the top position of the first
  // two cards. If they differ the cards are stacked — no equalisation needed.
  const cards = grid.querySelectorAll('.cta-card');
  if (cards.length >= 2 && cards[0].getBoundingClientRect().top !== cards[1].getBoundingClientRect().top) {
    return;
  }

  const maxH = Array.from(titles).reduce(function (max, t) {
    return Math.max(max, t.offsetHeight);
  }, 0);

  if (maxH > 0) {
    titles.forEach(function (t) { t.style.minHeight = maxH + 'px'; });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const grids = document.querySelectorAll('.cta-cards-grid');
  if (!grids.length) return;

  grids.forEach(equaliseCtaCardTitles);

  // Re-run after all resources (images, fonts) have loaded as they can
  // affect card dimensions.
  window.addEventListener('load', function () {
    grids.forEach(equaliseCtaCardTitles);
  });

  // Re-run on resize — debounced so it doesn't thrash layout during drag.
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      grids.forEach(equaliseCtaCardTitles);
    }, 150);
  });
});
